import(/* webpackMode: "eager" */ "/app/apps/armstrong/src/app/global-error.tsx");
